import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import UnderlinedButton from "Root/profile/components/common/UnderlinedButton";
import AllTeamImg from "./images/all-team.png";
import styles from "./styles.module.scss";
const ExploreAllTeamCard = ({ nextSlide }) => (_jsxs("div", { className: styles.explore_all, children: [_jsx("div", { className: styles.images, children: _jsx("img", { src: AllTeamImg, alt: "" }) }), _jsx(UnderlinedButton, { label: "Explore the team", onClick: nextSlide })] }));
export default ExploreAllTeamCard;
